<template>
    <div :class="['header', $store.getters.getNavOpen ? 'is-open':'']">
        <div class="header__inner">
            <div class="logo">
                <router-link to="/">Cubeplatform</router-link>
            </div>
            <div class="desktop-wrapper"
                v-if="$resize && $mq.above(1024)">
                <ul :class="['nav', 'is-lato', 'is-' + route]">
                    <li><router-link to="/about">ABOUT</router-link></li>
                    <li><router-link to="/business" @click.native="initType()">BUSINESS</router-link></li>
                    <li><router-link to="/globalnetwork">GLOBAL NETWORK</router-link></li>
                    <li>
                        <router-link to="/recruit">RECRUIT</router-link>
                        <span class="counter">
                            <span>1</span>
                        </span>
                    </li>
                </ul>
                <div class="locale-wrapper">
                    <ul :class="['locale', 'is-lato', 'is-' + locale]">
                        <li @click="setLocale('kr');">KR</li>
                        <li @click="message($t('alert.ready'))">EN</li>
                        <li @click="setLocale('jp');">JP</li>
                        <li @click="message($t('alert.ready'))">CN</li>
                    </ul>
                </div>
            </div>
            <div class="mobile-wrapper" v-else>
                <transition name="nav">
                <div class="mobile-wrapper__inner" v-show="$store.getters.getNavOpen">
                    <ul :class="['nav', 'is-lato', 'is-' + route]">
                        <li><router-link to="/about">ABOUT</router-link></li>
                        <li><router-link to="/business" @click="initType()">BUSINESS</router-link></li>
                        <li><router-link to="/globalnetwork">GLOBAL NETWORK</router-link></li>
                        <li>
                            <router-link to="/recruit">RECRUIT</router-link>
                            <span class="counter">
                                <span>1</span>
                            </span>
                        </li>
                    </ul>
                    <div class="locale-wrapper">
                        <ul :class="['locale', 'is-lato', 'is-' + locale]">
                            <li @click="setLocale('kr'); $store.commit('setNavOpen', false);">KR</li>
                            <li @click="message($t('alert.ready'))">EN</li>
                            <li @click="setLocale('jp'); $store.commit('setNavOpen', false);">JP</li>
                            <li @click="message($t('alert.ready'))">CN</li>
                        </ul>
                    </div>
                </div>
                </transition>
            </div>
            <button class="open-button" @click="setNavOpen">
                <span></span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    methods: {
        setLocale: function (lang) {
            this.$i18n.locale = lang
            this.$store.commit('setLocale', lang)
        },
        message: function (msg) {
            alert(msg)
        },
        setNavOpen: function () {
            var curNav = this.$store.getters.getNavOpen
            var header = document.getElementsByClassName('header')[0]
            this.$store.commit('setNavOpen', !curNav)
            if (this.$store.getters.getNavOpen) {
                header.style.zIndex = '99999'
            } else {
                setTimeout(function () {
                    header.style.zIndex = '10'
                }, 300)
            }
        },
        initType: function () {
            this.$store.commit('setBusinessType', 0)
        }
    },
    computed: {
        locale: function () {
            return this.$store.getters.getLocale
        },
        route: function () {
            var name = this.$route.path.split('')
            name.shift(1)
            name = name.join('')
            return name
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes gradient {
    0% {background-position: 0% 50%;}
    50% {background-position: 100% 50%;}
    100% {background-position: 0% 50%;}
}
@keyframes mobile-nav {
    0% {transform: scaleX(0);}
    100% {transform: scaleX(1);}
}
.header {
    position: fixed;
    z-index: 10;
    width: 100%;
    height: 80px;

    &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
        opacity: 1;
    }
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-bottom: 1px solid rgba(211, 211, 212, 0.4);
        opacity: 0;
    }
    &__inner {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        .logo {
            position: absolute;
            top: 50%;
            left: 60px;
            transform: translateY(-50%);
            a {
                display: block;
                width: 110px;
                height: 46px;
                background: url(../../assets/image/logo/logo_color_110.png) no-repeat center left;
                font-size: 0;
            }
        }
        @include over-desktop {
            .nav {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);

                & > li {
                    float: left;
                    position: relative;
                    margin-left: 60px;

                    &:first-child {
                        margin-left: 0;
                    }

                    & > a {
                        display: block;
                        position: relative;
                        color: #555;
                        font-weight: 700;
                        font-size: 15px;
                        line-height: 15px;

                        &::before {
                            @include gradient;
                            content: '';
                            position: absolute;
                            display: block;
                            bottom: -5px;
                            width: 100%;
                            height: 2px;
                            // background: rgba($color: #ea7a94, $alpha: 1);
                            transform: scaleX(0);
                            transform-origin: center left;
                            transition: transform 500ms;
                        }
                        &:hover::before {
                            transform: scaleX(1);
                        }
                    }
                    & > .router-link-active {
                        color: #ea7a94;
                    }
                    &:last-child {
                        .counter {
                            display: block;
                            position: absolute;
                            top: -10px;
                            right: -18px;
                            width: 14px;
                            height: 14px;
                            border-radius: 50%;
                            background: #ea7a94;
                            text-align: center;
                            span {
                                position: absolute;
                                top: 1px;
                                left: 48%;
                                z-index: 1;
                                color: #fff;
                                font-weight: 800;
                                font-size: 11px;
                                line-height: 11px;
                                transform: translateX(-50%);
                            }
                        }
                    }
                }
                &::before {
                    @include gradient;
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    bottom: -5px;
                    width: 100px;
                    height: 2px;
                    // background: #ea7a94;
                    opacity: 0;
                    transform: translateX(0) scaleX(0);
                    transform-origin: left;
                    transition: opacity 250ms, transform 250ms;
                }
                &.is-about::before {
                    opacity: 1;
                    transform: translateX(0) scaleX(0.52);
                }
                &.is-business::before {
                    opacity: 1;
                    transform: translateX(112px) scaleX(0.7);
                }
                &.is-globalnetwork::before {
                    opacity: 1;
                    transform: translateX(242px) scaleX(1.39);
                }
                &.is-recruit::before {
                    opacity: 1;
                    transform: translateX(441px) scaleX(0.62);
                }
            }
            .locale {
                position: absolute;
                top: 50%;
                right: 60px;
                transform: translateY(-50%);

                & > li {
                    float: left;
                    position: relative;
                    margin-left: 20px;
                    color: #555;
                    font-weight: 700;
                    font-size: 15px;
                    letter-spacing: -0.5px;
                    opacity: 0.5;
                    transition: opacity 150ms;
                    cursor: pointer;

                    &:first-child {
                        margin-left: 0;
                    }
                    &:hover {
                        opacity: 1;
                    }

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: -5px;
                        width: 100%;
                        height: 2px;
                        background: #555;
                        opacity: 0;
                        transform: scaleX(0);
                        transform-origin: top left;
                        transition: opacity 250ms, transform 250ms;
                    }
                    &:hover {
                        &::before {
                            opacity: 1;
                            transform: scaleX(1);
                        }
                    }
                }
                $locale-list: (1: kr, 2: en, 3: jp, 4: cn);
                @each $key, $value in $locale-list {
                    &.is-#{$value} {
                        & > li:nth-child(#{$key}) {
                            opacity: 1;

                            &::before {
                                opacity: 1;
                                transform: scaleX(1);
                            }
                        }
                    }
                }
            }
        }
    }
    &.is-top {
        position: absolute;
        top: 0;
        &::before {
            opacity: 0;
        }
        &::after {
            opacity: 1;
        }
        .logo {
            a {
                background: url(../../assets/image/logo/logo_white_110.png) no-repeat center left;
                background-size: 100% auto;
            }
        }
        .nav {
            &::before {
                background: #fff;
            }
            & > li > a{
                color: #fff;
                @include over-desktop {
                    &::before {
                        background: rgba($color: #fff, $alpha: 0.5);
                    }
                }
            }
            & > li:last-child {
                .counter {
                    background: #fff;
                    span {
                        color: #9173c0;
                    }
                }
            }
        }
        .locale {
            & > li {
                color: #fff;
                &::before {
                    background: #fff;
                }
            }
        }
    }
    &.is-main {
        @include over-desktop {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            &::before,
            &::after {
                display: none;
            }
            .logo {
                display: none;
                // top: 75px;
                // a {
                //     background: url(../../assets/image/logo/logo_white.png) no-repeat center left;
                //     background-size: 100% auto;
                // }
            }
            .nav {
                left: initial;
                top: 75px;
                // right: 60px;
                right: 78px;
                transform: translateY(-50%);
                &::before {
                    background: #fff;
                }
                & > li {
                    float: left;
                    margin-left: 60px;
                    & > a {
                        color: #fff;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 16px;
                        &::before {
                            bottom: -4px;
                            background: rgba($color: #fff, $alpha: 1);
                        }
                    }
                    &:last-child {
                        .counter {
                            background: #fff;
                            span {
                                color: #9173c0;
                            }
                        }
                    }
                }
            }
            .locale-wrapper {
                position: absolute;
                top: 0;
                left: 0;
                height: 100vh;
            }
            .locale {
                right: initial;
                left: 60px;
                text-align: center;
                & > li {
                    float: initial;
                    display: block;
                    margin-left: 0;
                    margin-bottom: 30px;
                    font-size: 14px;
                    line-height: 14px;
                    letter-spacing: 0;
                    color: #fff;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    &::before {
                        background: #fff;
                    }
                }
                &.is-jp {
                    & > li::before {
                        width: 80%;
                    }
                }
            }
        }
    }
    @include under-tablet {
        height: 70px;
        &__inner {
            .mobile-wrapper__inner {
                @include gradient-45-trans;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100vh;
                background-size: 1200%;
                animation: gradient 14s infinite;
            }
            .logo {
                left: 28px;
                a {
                    width: 77px;
                    height: 32px;
                    background: url(../../assets/image/logo/logo_color_m.png) no-repeat center left;
                    background-size: 100% auto;
                }
            }
            .nav {
                position: relative;
                padding-top: 28vh;
                // top: 42%;
                left: 64px;
                // transform: translateY(-50%);
                & > li {
                    position: relative;
                    margin-top: 7.6vw;

                    &:first-child {
                        margin-top: 0;
                    }
                    a {
                        position: relative;
                        display: inline-block;
                        color: #fff;
                        font-size: 6.4vw;
                        line-height: 6.4vw;
                        outline: none;
                        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                        &::before {
                            content: '';
                            display: block;
                            position: absolute;
                            bottom: -3px;
                            left: 0;
                            width: 100%;
                            height: 1px;
                            background: #fff;
                            transform: scaleX(0);
                            transform-origin: center left;
                            // transition: transform 250ms;
                        }
                    }
                    &:last-child {
                        .counter {
                            display: inline-block;
                            position: relative;
                            top: -3.4vw;
                            left: 1vw;
                            width: 4vw;
                            height: 4vw;
                            border-radius: 2.5vw;
                            background: #fff;
                            font-weight: 800;
                            text-align: center;
                            span {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                z-index: 1;
                                color: #fff;
                                font-weight: 800;
                                font-size: 3vw;
                                line-height: 3vw;
                                transform: translate(-50%, -50%);
                            }
                        }
                    }
                    .router-link-active {
                        &::before {
                            content: '';
                            // transform: scaleX(1);
                            // transition: transform 250ms;
                            transform: scaleX(1);
                            animation: mobile-nav 300ms backwards;
                        }
                    }
                }
                // &::before {
                //     content: '';
                //     display: block;
                //     position: absolute;
                //     left: -36px;
                //     width: 16px;
                //     height: 6vw;
                //     background: #fff;
                //     opacity: 0;
                //     transform-origin: left;
                //     transition: opacity 150ms, transform 150ms;
                // }
                // $nav-list: (about: 0, business: 14, globalnetwork: 28, recruit: 42);
                // @each $key, $value in $nav-list {
                //     $i: index(($nav-list), ($key, $value));
                //     &.is-#{$key} {
                //         &::before {
                //             opacity: 0.7;
                //             transform: translateY(#{$value}vw);
                //         }
                //     }
                // }
            }
            .locale {
                // position: absolute;
                // bottom: 22%;
                // left: 28px;
                // left: 44px;
                // transform: translateY(-50%);
                position: relative;
                left: 64px;
                margin-top: 20%;
                z-index: 10;
                & > li {
                    float: left;
                    position: relative;
                    margin-left: 3.4vw;
                    color: #fff;
                    font-size: 3.4vw;
                    letter-spacing: -0.5px;
                    opacity: 0.5;
                    transition: opacity 150ms;
                    cursor: pointer;

                    &:first-child {
                        margin-left: 0;
                    }

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: -3px;
                        width: 100%;
                        height: 2px;
                        background: #fff;
                        opacity: 0;
                    }
                }
                $locale-list: (1: kr, 2: en, 3: jp, 4: cn);
                @each $key, $value in $locale-list {
                    &.is-#{$value} {
                        & > li:nth-child(#{$key}) {
                            opacity: 1;

                            &::before {
                                opacity: 1;
                            }
                        }
                    }
                }
            }
            .open-button {
                position: absolute;
                top: 50%;
                // right: 28px;
                right: 25px;
                width: 30px;
                height: 30px;
                transform: translateY(-50%);
                cursor: pointer;

                span {
                    display: block;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 24px;
                    height: 2px;
                    background: #433d84;
                    opacity: 1;
                    transform: translate(-50%, -50%);
                    transition: opacity 250ms;
                }
                &::before,
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 24px;
                    height: 2px;
                    background: #433d84;
                    transform-origin: center center;
                    transition: transform 150ms;
                }
                &::before {
                    transform: translate(-50%, -500%) rotate(0);
                    // animation: closeBefore 500ms forwards;
                }
                &::after {
                    transform: translate(-50%, 400%) rotate(0);
                    // animation: closeAfter 500ms forwards;
                }
            }
        }
        &.is-open {
            position: fixed;
            overflow: visible;
            z-index: 99999;
            .header__inner {
                .logo {
                    z-index: 10;
                    a {
                        background: url(../../assets/image/logo/logo_white.png) no-repeat center left;
                        background-size: 100% auto;
                    }
                }
                .open-button {
                    span {
                        opacity: 0;
                    }
                    &::before {
                        background: #fff;
                        transform: translate(-50%, -50%) rotate(45deg);
                    }
                    &::after {
                        background: #fff;
                        transform: translate(-50%, -50%) rotate(-45deg);
                    }
                }
                .nav {
                    & > li:last-child {
                        .counter {
                            background: #fff;
                            span {
                                color: #9173c0;
                            }
                        }
                    }
                }
            }
        }
        &.is-main {
            // display: none;
            position: absolute;
            top: 0;
            &::before {
                opacity: 0;
            }
            &::after {
                opacity: 0;
            }
            .nav {
                & > li:last-child {
                    .counter {
                        background: #fff;
                        span {
                            color: #9173c0;
                        }
                    }
                }
            }
        }
        &.is-top {
            .logo {
                a {
                    background: url(../../assets/image/logo/logo_white_m.png) no-repeat center left;
                    background-size: 100% auto;
                }
            }
            .open-button {
                span,
                &::before,
                &::after {
                    background: #fff;
                }
            }
        }
        &.is-main {
            .header__inner {
                .logo {
                    z-index: 10;
                    a {
                        background: url(../../assets/image/logo/logo_white.png) no-repeat center left;
                        background-size: 100% auto;
                    }
                }
                .open-button {
                    span,
                    &::before,
                    &::after {
                        background: #fff;
                    }
                }
            }
        }
    }
    @include mobile {
        height: 54px;
        &__inner {
            .logo {
                left: 20px;
            }
            .nav {
                left: 36px;
                &::before {
                    left: -16px;
                    width: 8px;
                }
            }
            .locale {
                left: 36px;
                & > li {
                    margin-left: 4.2vw;
                    font-size: 4.2vw;
                }
            }
            .open-button {
                // right: 20px;
                right: 17px;
            }
        }
    }
}
.nav-enter,
.nav-leave-to {
    // opacity: 0;
    transform: translateX(100%);
}
.nav-enter-active {
    // transition: opacity 300ms, transform 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1);
    // transition: opacity 500ms;
}
.nav-leave-active {
    // transition: opacity 100ms 200ms, transform 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1);
}
.nav-enter-to,
.nav-leave {
    // opacity: 1;
    transform: translateX(0%);
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue